{
  "toast": {
    "aBTestStarted": "A/B test started",
    "draftCampaignCreated": "Draft campaign created",
    "campaignScheduled": "Campaign scheduled",
    "journeyCreated": "Journey created",
    "journeyFlowSaved": "Journey flow saved",
    "segmentSaved": "Segment saved",
    "templateSaved": "Template saved",
    "templateCompiled": "Template compiled",
    "calendarEntryCreated": "Calendar entry created",
    "reportExported": "{{reportType}} exported",
    "draftCreated": "Draft created: {{name}}",
    "abWinner": "Winner: variant {{variant}}",
    "recipientSuppressed": "Recipient suppressed",
    "suppressionReleased": "Suppression released",
    "assetSaved": "Asset saved"
  },
  "errors": {
    "failedToLoadABTests": "Failed to load A/B tests",
    "failedToCreateABTest": "Failed to create A/B test",
    "failedToPickWinner": "Failed to pick winner",
    "enterACampaignName": "Enter a campaign name",
    "selectAnAudienceSegment": "Select an audience segment",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadSegments": "Failed to load segments",
    "failedToLoadTemplates": "Failed to load templates",
    "failedToCreateCampaign": "Failed to create campaign",
    "actionFailed": "Action failed",
    "failedToLoadPerformance": "Failed to load performance",
    "attributionFailed": "Attribution failed",
    "failedToLoadJourneys": "Failed to load journeys",
    "failedToCreateJourney": "Failed to create journey",
    "failedToSaveJourneyFlow": "Failed to save journey flow",
    "failedToLoadLifecyclePresets": "Failed to load lifecycle presets",
    "exportFailed": "Export failed",
    "failedToCreateSegment": "Failed to create segment",
    "previewFailed": "Preview failed",
    "templateNameIsRequired": "Template name is required",
    "failedToCreateTemplate": "Failed to create template",
    "failedToCreateCalendarEntry": "Failed to create calendar entry",
    "failedToGenerateAiContent": "Failed to generate AI content",
    "failedToSuppressRecipient": "Failed to suppress recipient",
    "failedToReleaseSuppression": "Failed to release suppression",
    "failedToSaveAsset": "Failed to save asset"
  },
  "pages": {
    "noCampaignSelected": "No campaign selected",
    "selectACampaignFromTheList": "Select a campaign from the list to view delivery and engagement metrics.",
    "noAttributionData": "No attribution data",
    "scheduleCampaign": "Schedule campaign",
    "campaigns": "Campaigns",
    "noCampaignsYet": "No campaigns yet",
    "createApproveScheduleAndLaunchMulti": "Create, approve, schedule, and launch multi-channel campaigns with tracked delivery.",
    "createADraftWithAnAudience": "Create a draft with an audience segment and template, then submit for approval.",
    "marketing": "Marketing",
    "engagement": "Engagement",
    "openRate": "Open rate",
    "conversions": "Conversions",
    "engagementFunnel": "Engagement funnel",
    "campaignPerformanceEngagementAndConversionsFor": "Campaign performance, engagement, and conversions for your marketing scope",
    "espWebhooks": "ESP webhooks",
    "sendgridMailgunAndSimilarProvidersPost": "SendGrid, Mailgun, and similar providers POST open/click events to update campaign metrics",
    "journeys": "Journeys",
    "noJourneys": "No journeys",
    "automateNurtureFlowsWithTriggersActions": "Automate nurture flows with triggers, actions, delays, and goals using a visual step builder.",
    "createAJourneyToAutomateFollow": "Create a journey to automate follow-ups after key events.",
    "lifecycle": "Lifecycle",
    "oneClickDraftsForWelcomeCart": "One-click drafts for welcome, cart recovery, win-back, upsell, and renewal programs.",
    "reports": "Reports",
    "exportCampaignAndJourneyDataAnd": "Export campaign and journey data, and inspect multi-touch attribution per campaign.",
    "audienceSegments": "Audience segments",
    "noSegmentsYet": "No segments yet",
    "dynamicSegmentsWithRuleBuilderAnd": "Dynamic segments with rule builder and live preview",
    "createYourFirstDynamicAudienceSegment": "Create your first dynamic audience segment.",
    "templates": "Templates",
    "noTemplates": "No templates",
    "reusableEmailContentWithVersioningVia": "Reusable email content with versioning via the shared template service.",
    "createATemplateToAttachTo": "Create a template to attach to email campaigns.",
    "marketingCopilot": "Marketing copilot",
    "generateCampaignCopySubjectLines": "Generate campaign copy, subject lines, channel recommendations, and next-best-action guidance.",
    "copilot": "Copilot",
    "result": "Result",
    "consentAndSuppression": "Consent & suppression",
    "reviewRecipientsBlockedByOptOuts": "Review recipients blocked by opt-outs, bounces, complaints, or manual suppression.",
    "suppressionList": "Suppression list",
    "loadingSuppressions": "Loading suppressions...",
    "noSuppressedRecipients": "No suppressed recipients.",
    "contentAndMediaLibrary": "Content & media library",
    "manageReusableMarketingAssets": "Manage reusable marketing assets for campaigns, landing pages, and templates.",
    "mediaLibrary": "Media library",
    "formsAndLandingPages": "Forms & landing pages",
    "marketingReusesLeadGenBuilders": "Marketing reuses the existing Lead Gen acquisition builders so capture, consent, scoring, and routing stay centralized.",
    "forms": "Forms",
    "createEmbeddedLeadRegistrationSurvey": "Create embedded lead, registration, survey, and feedback forms in Lead Gen.",
    "landingPages": "Landing pages",
    "buildCampaignLandingPages": "Build campaign landing pages with SEO, conversion tracking, and A/B variants in Lead Gen.",
    "visitorTracking": "Visitor tracking",
    "reviewFirstPartyWebsiteTracking": "Review first-party website tracking, attribution, and visitor-to-lead conversion."
  },
  "calendar": {
    "title": "Marketing calendar",
    "description": "Plan launches, newsletters, nurture waves, and channel activities from a shared campaign calendar.",
    "breadcrumb": "Calendar",
    "labels": {
      "activityTitle": "Activity title"
    },
    "actions": {
      "add": "Add"
    },
    "sections": {
      "upcomingMarketingActivities": "Upcoming marketing activities"
    },
    "defaults": {
      "marketingActivity": "Marketing activity"
    },
    "loading": "Loading calendar...",
    "empty": "No calendar entries in this period.",
    "campaignLabel": "Campaign #{{id}}"
  },
  "channels": {
    "title": "SMS & WhatsApp campaigns",
    "description": "Manage non-email marketing campaigns that are delivered through the shared Social messaging services.",
    "breadcrumb": "Channels",
    "createCampaign": "Create campaign",
    "searchCampaigns": "Search campaigns",
    "channelCampaigns": "{{channel}} campaigns",
    "loadingCampaigns": "Loading campaigns...",
    "noCampaignsFound": "No {{channel}} campaigns found. Create one from the main campaign workspace.",
    "budgetCost": "Budget {{budget}} · Cost {{cost}}",
    "open": "Open"
  },
  "templates": {
    "sections": {
      "newEmailTemplate": "New email template",
      "visualBlocks": "Visual blocks",
      "library": "Library"
    },
    "actions": {
      "addBlock": "Add block",
      "saveTemplate": "Save template",
      "compileHtml": "Compile HTML"
    },
    "blockTypes": {
      "heading": "Heading",
      "text": "Text",
      "button": "Button",
      "image": "Image"
    },
    "placeholders": {
      "imageUrl": "Image URL",
      "content": "Content",
      "buttonUrl": "Button URL"
    },
    "defaultBlocks": {
      "heading": "Welcome to our latest update",
      "text": "Add your marketing message here.",
      "button": "Learn more",
      "newContentBlock": "New content block"
    },
    "status": {
      "published": "published"
    },
    "versionLabel": "v{{version}}",
    "loading": "Loading..."
  },
  "labels": {
    "variantARef": "Variant A ref",
    "variantBRef": "Variant B ref",
    "sent": "Sent",
    "opens": "Opens",
    "clicks": "Clicks",
    "bounces": "Bounces",
    "unsubscribes": "Unsubscribes",
    "conversions": "Conversions",
    "openRate": "Open rate",
    "clickRate": "Click rate",
    "roi": "ROI",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeStep": "Remove step",
    "stepType": "Step type",
    "action": "Action",
    "waitAmount": "Wait amount",
    "unit": "Unit",
    "displayLabel": "Display label",
    "sendAt": "Send at",
    "matchMode": "Match mode",
    "field": "Field",
    "operator": "Operator",
    "value": "Value",
    "name": "Name",
    "channel": "Channel",
    "audience": "Audience",
    "template": "Template",
    "springPromo": "Spring promo",
    "selectSegment": "Select segment",
    "optional": "Optional",
    "trigger": "Trigger",
    "welcomeSeries": "Welcome series",
    "audienceOptional": "Audience (optional)",
    "useDefaultRules": "Use default rules",
    "campaign": "Campaign",
    "model": "Model",
    "selectCampaign": "Select campaign",
    "allModels": "All models",
    "segmentName": "Segment name",
    "templateName": "Template name",
    "subjectLine": "Subject line",
    "bodyHtmlOrPlainText": "Body (HTML or plain text)",
    "task": "Task",
    "goal": "Goal",
    "tone": "Tone",
    "source": "Source",
    "recipient": "Recipient",
    "assetName": "Asset name",
    "type": "Type",
    "fileUrl": "File URL",
    "date": "Date"
  },
  "options": {
    "task": {
      "campaignCopy": "Campaign copy",
      "subjectLine": "Subject line",
      "smsCopy": "SMS copy",
      "whatsAppCopy": "WhatsApp copy",
      "channelRecommendation": "Channel recommendation",
      "nextBestAction": "Next best action"
    },
    "channel": {
      "email": "Email",
      "sms": "SMS",
      "whatsApp": "WhatsApp",
      "multiChannel": "Multi-channel"
    },
    "segmentField": {
      "leadScore": "Lead score",
      "purchaseHistory": "Purchase history (POS)",
      "expectedRevenue": "Expected revenue",
      "location": "Location",
      "emailActivity": "Email activity",
      "campaignActivity": "Campaign activity",
      "websiteActivity": "Website activity"
    },
    "operator": {
      "contains": "contains"
    },
    "matchMode": {
      "anyRule": "Any rule (OR)",
      "allRules": "All rules (AND)"
    },
    "assetType": {
      "image": "Image",
      "video": "Video",
      "document": "Document"
    }
  },
  "placeholders": {
    "newLeads": "new leads",
    "bookAProductDemo": "book a product demo",
    "professional": "professional",
    "generatedContentWillAppearHere": "Generated content will appear here.",
    "recipientAddressOrPhone": "email@example.com or +15551234567"
  },
  "formActions": {
    "createDraft": "Create draft",
    "generate": "Generate",
    "remove": "Remove",
    "addRuleGroup": "+ Add rule group",
    "suppress": "Suppress",
    "release": "Release",
    "save": "Save"
  },
  "listActions": {
    "newCampaign": "New campaign",
    "openBuilder": "Open builder"
  },
  "empty": {
    "noMarketingAssetsYet": "No marketing assets yet."
  },
  "loading": {
    "assets": "Loading assets..."
  }
}
